import { Currency } from '@shared/constants/currency';

export function cleanPetValueCurrency(petValue: string) {
  return petValue.replaceAll(Currency.GBP, '');
}
